import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MarineGroup } from 'app/classes/marine-group';
import { AuthService } from 'app/services/auth.service';
import { GroupDataService } from 'app/services/group-data.service';
import { Subscription } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';

export interface SelectGroupsDialogComponentData {
  selected: string[];
}

@Component({
  selector: 'select-groups-dialog',
  templateUrl: './select-groups-dialog.component.html',
  styleUrls: ['./select-groups-dialog.component.scss'],
})
export class SelectGroupsDialogComponent implements OnInit, OnDestroy {
  groups: MarineGroup[];
  selectedGroups = {};
  searchText: string;
  loading: boolean;
  private sub: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SelectGroupsDialogComponentData,
    private groupDataService: GroupDataService,
    private authService: AuthService,
    private dialog: MatDialogRef<SelectGroupsDialogComponent>,
  ) {}

  ngOnInit() {
    this.loading = true;

    this.sub = this.groupDataService.groups
      .pipe(
        concatMap((groups: MarineGroup[]) => {
          return this.authService.currentUserObs.pipe(
            tap(user => {
              this.groups = groups.filter(group => group.owners.some(owner => owner.uuid === user.uuid));
              this.groups.forEach(group => {
                this.selectedGroups[group.uuid] = { checked: this.data.selected.indexOf(group.uuid) > -1 };
              });

              this.loading = false;
            }),
          );
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  close() {
    const selectedUUIDs = [];

    Object.keys(this.selectedGroups).forEach(key => {
      if (this.selectedGroups[key] && this.selectedGroups[key].hasOwnProperty('checked') && this.selectedGroups[key].checked) {
        selectedUUIDs.push(key);
      }
    });

    this.dialog.close(selectedUUIDs);
  }
}
